import { useI18n } from '../../i18n';
import React from 'react';
import {
  CONTRACT_HOUR_BANDS,
  contractBandKey,
  findContractBand,
  type ContractHoursBand,
} from '../../services/staffService';
import { contractBandLabel } from './staffPresentation';

interface Props {
  id: string;
  value: ContractHoursBand | null;
  onChange: (band: ContractHoursBand | null) => void;
  disabled?: boolean;
  invalid?: boolean;
}

/** The weekly band a guard is contracted for, from the one list the database accepts. */
export default function ContractHoursSelect({ id, value, onChange, disabled = false, invalid = false }: Props) {
  const { t } = useI18n();
  return (
    <select
      id={id}
      className="form__select"
      value={value ? contractBandKey(value) : ''}
      onChange={(event) => onChange(findContractBand(event.target.value))}
      disabled={disabled}
      aria-invalid={invalid || undefined}
    >
      <option value="">{t('Choose a band')}</option>
      {CONTRACT_HOUR_BANDS.map((band) => (
        <option key={contractBandKey(band)} value={contractBandKey(band)}>{contractBandLabel(band)}</option>
      ))}
    </select>
  );
}
